import { IBlockMultimediaProgressModel } from 'models/block.model'
import api from '../..'

export const getMultimediaBlockProgress = (
  blockInstanceId: number,
  courseId: number
) => {
  return api
    .get(`block_instances_progress/${blockInstanceId}?course_id=${courseId}`)
    .then(({ data }): IBlockMultimediaProgressModel => {
      return data
    })
}
